export enum SubmitDialogPropertySize {
  Narrow = 'narrow',
  FullWidth = 'full-width',
}
